/**
 * Curated proof content — fill in as assets and copy become available.
 * Sections with empty data are hidden on the Proof page.
 */

import expRealtyLogo from '../../assets/images/advertisers/exp-realty.png';
import upsideLogo from '../../assets/images/advertisers/upside.png';
import urbanGirlsLogo from '../../assets/images/advertisers/2-urban-girls.png';
import retroBrandLogo from '../../assets/images/advertisers/the-retro-brand.png';

export const FOUNDER_STORY = {
  name: 'Ephrem Adugna',
  headline: 'Built in Inglewood, for local businesses everywhere.',
  paragraphs: [
    "I founded INVERT while studying Computer Science and Business Administration at USC after realizing how much unused screen space already exists in everyday places like restaurants, juice bars, and storefronts.",
    "We started in Inglewood because it is one of the most exciting event-driven markets in the country. Between local residents, repeat neighborhood traffic, and major venues nearby, it is the ideal place to prove a hyper-local advertising network.",
    "Our goal is simple: help local businesses earn passive revenue from their screens while giving advertisers access to real people in real places where attention is high and repetition is natural.",
    "INVERT is being built one location at a time, with a focus on real screens, real foot traffic, and real neighborhood impact."
  ],
  photo: null,
};

export const LIVE_NETWORK = {
  screens: 9,
  city: 'Inglewood, CA',
  timezone: 'America/Los_Angeles',
  locations: [
    {
      id: 4208,
      name: 'Pioneer Juice Bar',
      address: '310 E Florence Ave, Inglewood, CA 90301',
      latitude: 33.96683198077802,
      longitude: -118.35110833593673,
      type: 'Indoor TV',
      size: '55in',
      brand: 'Pioneer',
      orientation: 'landscape',
      direction: 'left',
      installedOn: '2026-03-30',
      notes: 'Placed in a juice bar. Gets consistent foot traffic and is visible throughout the location.',
      image: 'https://uinvert.blob.core.windows.net/screen-images/listingScreen4208-1781147645605-ef1f6fcb.jpg',
      hours: 'Daily 7:00 AM–10:00 PM',
      visibility: 'Indoor, visible throughout location',
    },
    {
      id: 4210,
      name: 'Antojitos Martin Juice Bar',
      address: '1300 Centinela Ave STE 103, Inglewood, CA 90302',
      latitude: 33.977003664252464,
      longitude: -118.3618068423163,
      type: 'Portrait Indoor TV',
      size: '55in',
      brand: 'Hisense',
      orientation: 'portrait',
      direction: 'left',
      installedOn: null,
      notes: 'Portrait orientation TV placed inside the juice bar. Immediately visible on entrance and visible throughout the store.',
      image: 'https://uinvert.blob.core.windows.net/screen-images/listingScreen4210-1781147673496-16dbcc4b.jpg',
      hours: 'Daily 7:00 AM–8:00 PM',
      visibility: 'Immediately visible on entry',
    },
    {
      id: 4211,
      name: 'Fiesta Martin Mexican Grill',
      address: '1330 N La Brea Ave, Inglewood, CA 90302',
      latitude: 33.9802416370103,
      longitude: -118.35789674718053,
      type: 'Indoor TV',
      size: '55in',
      brand: 'Hisense',
      orientation: 'landscape',
      direction: 'left',
      installedOn: null,
      notes: 'Restaurant TV positioned inside the restaurant. Visible to customers inside the restaurant.',
      image: 'https://uinvert.blob.core.windows.net/screen-images/listingScreen4211-1781147710522-3921820e.jpg',
      hours: 'Daily 8:00 AM–10:00 PM',
      visibility: 'Visible to customers inside',
    },
    {
      id: 4212,
      name: 'Fiesta Martin Mexican Grill',
      address: '7929 S Van Ness Ave, Inglewood, CA 90305',
      latitude: 33.96621495520827,
      longitude: -118.31793577929996,
      type: 'Indoor TV',
      size: '55in',
      brand: 'Hisense',
      orientation: 'landscape',
      direction: 'left',
      installedOn: '2026-05-04',
      notes: 'Indoor TV at the bar facing the entrance. Visible to people entering the restaurant and people seated at the bar.',
      image: 'https://uinvert.blob.core.windows.net/screen-images/listingScreen4212-1781147725276-46266e84.jpg',
      hours: 'Daily 8:00 AM–10:00 PM',
      visibility: 'Visible on entry and at bar',
    },
    {
      id: 4223,
      name: 'Manchester Blvd Screen',
      address: '450 E Manchester Blvd, Inglewood, CA 90301',
      latitude: 33.961796425754194,
      longitude: -118.34929095767228,
      type: 'Indoor TV',
      size: '55in',
      brand: 'Samsung',
      orientation: 'landscape',
      direction: 'left',
      installedOn: '2026-05-04',
      notes: 'Indoor TV, immediately visible on entry.',
      image: 'https://uinvert.blob.core.windows.net/screen-images/listingScreen4223-1781147753107-32ec2389.jpg',
      hours: 'Daily 7:00 AM–12:00 AM',
      visibility: 'Immediately visible on entry',
    },
    {
      id: 4224,
      name: 'Manchester Blvd Storefront',
      address: '450 E Manchester Blvd, Inglewood, CA 90301',
      latitude: 33.961796425754194,
      longitude: -118.34929095767228,
      type: 'Outdoor Facing LED Screen',
      size: '57in',
      brand: 'LED SCREEN',
      orientation: 'portrait',
      direction: 'left',
      installedOn: '2026-05-04',
      notes: 'Outdoor facing storefront screen. Very bright, placed at an intersection with stopped traffic and a bus stop.',
      image: 'https://uinvert.blob.core.windows.net/screen-images/listingScreen4224-1781147769212-8e92a92e.jpg',
      hours: null,
      visibility: 'Street-facing, high-visibility outdoor placement',
    },
    {
      id: 4257,
      name: 'Manchester Blvd Storefront',
      address: '316 E Manchester Blvd, Inglewood, CA 90301',
      latitude: 33.96173517809899,
      longitude: -118.35124948682139,
      type: 'Storefront Screen',
      size: '43in',
      brand: 'Samsung TV',
      orientation: 'landscape',
      direction: 'left',
      installedOn: '2026-05-29',
      notes: 'Indoor screen immediately visible to people entering the store.',
      image: 'https://uinvert.blob.core.windows.net/screen-images/listingScreen4257-1781147791965-4c3aa884.jpg',
      hours: 'Weekdays 9:30 AM–6:00 PM',
      visibility: 'Immediately visible on entry',
    },
    {
      id: 4277,
      name: 'Ethiopian Restaurant Screen',
      address: '1513 Centinela Ave, Inglewood, CA 90302',
      latitude: 33.97674781168718,
      longitude: -118.36542860457139,
      type: 'Indoor TV',
      size: '55in',
      brand: 'Samsung',
      orientation: 'landscape',
      direction: 'none',
      installedOn: '2026-06-03',
      notes: 'Indoor TV at an Ethiopian restaurant facing all occupants.',
      image: 'https://uinvert.blob.core.windows.net/screen-images/listingScreen4277-1781147859422-6fad3a5f.jpg',
      hours: null,
      visibility: 'Facing all occupants',
    },
    {
      id: 4284,
      name: 'La Brea Storefront',
      address: '1216 N La Brea Ave, Inglewood, CA 90302',
      latitude: 33.979035452144494,
      longitude: -118.35745690674611,
      type: 'Indoor Landscape TV',
      size: '55in',
      brand: 'Samsung',
      orientation: 'landscape',
      direction: 'none',
      installedOn: '2026-06-05',
      notes: 'Visible to all customers inside the store upon entry.',
      image: 'https://uinvert.blob.core.windows.net/screen-images/listingScreen4284-1780710229439-b636e1eb.jpg',
      hours: 'Daily 11:00 AM–7:00 PM, Saturday until 5:00 PM',
      visibility: 'Visible to all customers upon entry',
    },
  ],
};

export const TESTIMONIALS = [
  // Add real testimonials only.
];

export const CAMPAIGN_EXAMPLES = [
  // Add real campaigns with images and results.
];

export const BEFORE_AFTER = [
  // Add storefront before/after installation photos.
];

export const VIDEO_PROOF = [
  // Restaurant walkthroughs, screen installs, customer reactions.
];

export const DASHBOARD_SCREENSHOTS = [
  // Dashboard screenshots with sensitive information removed.
];

export const PARTNER_LOGOS = [
  // Add logos as partnerships become public.
];

export const ADVERTISER_LOGOS = [
  {
    name: 'Eena Douglass-Harris / EXP Realty',
    label: 'EXP Realty',
    logo: expRealtyLogo,
    website: null,
  },
  {
    name: 'Wendell Muhammad',
    label: 'Upside',
    logo: upsideLogo,
    website: null,
  },
  {
    name: 'Urban Girls',
    label: '2 Urban Girls',
    logo: urbanGirlsLogo,
    website: 'https://2urbangirls.com',
  },
  {
    name: 'Dimico Chisolm',
    label: 'The Retro Brand',
    logo: retroBrandLogo,
    website: null,
  },
];

/** Returns entries that have the required content to render. */
export function getFilledTestimonials() {
  return TESTIMONIALS.filter((t) => t.quote && t.quote.trim());
}

export function getFilledCampaignExamples() {
  return CAMPAIGN_EXAMPLES.filter((c) => c.image && c.title);
}

export function getFilledBeforeAfter() {
  return BEFORE_AFTER.filter((b) => b.before && b.after);
}

export function getFilledVideos() {
  return VIDEO_PROOF.filter((v) => v.src);
}

export function getFilledDashboardScreenshots() {
  return DASHBOARD_SCREENSHOTS.filter((d) => d.src);
}

export function hasFounderStory() {
  return (
    (FOUNDER_STORY.paragraphs &&
      FOUNDER_STORY.paragraphs.some((p) => p && p.trim())) ||
    (FOUNDER_STORY.name && FOUNDER_STORY.name.trim())
  );
}

export function hasLiveNetwork() {
  return Boolean(LIVE_NETWORK?.locations?.length);
}

export function getLiveNetworkLocations() {
  return LIVE_NETWORK.locations.filter((loc) => loc.image && loc.address);
}